const REAL = {
  homeAppliances: "https://static.wixstatic.com/media/11062b_51cf43307fe04a5fbd90f0136b8b2e07~mv2.jpeg",
  inHome: "https://static.wixstatic.com/media/af8bb00e66c944e5bbfb2f85acfb2c63.jpg",
  hypermart: "https://static.wixstatic.com/media/11062b_9c7cdea7e0b6473cb53bc25b853ae308~mv2.jpg",
};
const STOCK = {
  living: "https://images.unsplash.com/photo-1757924461488-ef9ad0670978?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  kitchenOvens: "https://images.pexels.com/photos/8082222/pexels-photo-8082222.jpeg?auto=compress&w=1400",
  kitchenShow: "https://images.pexels.com/photos/7614540/pexels-photo-7614540.jpeg?auto=compress&w=1400",
  furniture: "https://images.unsplash.com/photo-1693578616322-c8abe6c7393d?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
};

export const DIVISIONS = [
  {
    slug: "home-appliances",
    name: "Konattu Home Appliances",
    kicker: "KONATTU BRANDED",
    tagline: "The brands you trust, priced right.",
    phone: "8086568787",
    intro:
      "Where it all began in 1998. Our home appliance showrooms carry national and international brands at reasonable rates, with the better service that made Konattu one of Kerala's leading branded appliance dealers.",
    accent: "#EF1221",
    photos: true,
    hero: REAL.homeAppliances,
    gallery: [REAL.homeAppliances, STOCK.kitchenShow, STOCK.kitchenOvens, STOCK.living],
    products: ["Televisions", "Refrigerators", "Washing Machines", "Air Conditioners", "Kitchen Appliances", "Water Purifiers"],
    features: ["Authorised brand dealer", "Reasonable, honest pricing", "Dependable after sales service", "EMI and finance options"],
  },
  {
    slug: "inhome",
    name: "Konattu InHome",
    kicker: "FURNITURE",
    tagline: "Turning a house into a home.",
    phone: "8086568787",
    intro:
      "Exclusive furniture stores to furnish every room beautifully, with thoughtfully built pieces at comfortable prices. From living room statements to everyday essentials, InHome helps Kerala families create spaces they love.",
    accent: "#EF1221",
    photos: true,
    hero: REAL.inHome,
    gallery: [REAL.inHome, STOCK.furniture, STOCK.living, STOCK.kitchenShow],
    products: ["Sofas and Recliners", "Beds and Mattresses", "Dining Sets", "Wardrobes", "Office Furniture", "Home Decor"],
    features: ["Solid wood and modular ranges", "Custom orders welcome", "Delivery and assembly", "Durable, tested build quality"],
  },
  {
    slug: "hypermart",
    name: "Konattu Hypermart",
    kicker: "HYPERMARKET",
    tagline: "Everything, under one roof.",
    phone: "8086568787",
    intro:
      "Our hypermart stores bring everyday essentials, groceries and home needs together in one convenient destination. It is the same Konattu trust, now with the ease of a single stop.",
    accent: "#EF1221",
    photos: true,
    hero: REAL.hypermart,
    gallery: [REAL.hypermart, STOCK.kitchenOvens, STOCK.kitchenShow, STOCK.living],
    products: ["Groceries", "Home Essentials", "Small Appliances", "Kitchenware", "Personal Care", "Seasonal Picks"],
    features: ["One stop convenience", "Everyday low prices", "Seasonal Mood Offers", "Family friendly aisles"],
  },
  {
    slug: "kitchen-lounges",
    name: "Kitchen Lounges",
    kicker: "ENDORSED BRAND · CROCKERY",
    tagline: "The kitchen as a gathering space.",
    phone: "8086568787",
    intro:
      "Crockery and homeware for the moments that matter, where meals become memories. Kitchen Lounges trades under its own wine and magenta identity, endorsed by Konattu Group for the trust behind it.",
    accent: "#A3295C",
    bg: "linear-gradient(150deg,#630933,#A3295C)",
    photos: false,
    products: ["Dinner Sets", "Cookware", "Glassware", "Serveware", "Kitchen Storage", "Gifting Sets"],
    features: ["Curated homeware brands", "Elegant gifting ranges", "Lifestyle led displays", "by Konattu Group"],
  },
  {
    slug: "emilia",
    name: "Emilia, The Beauty Hub",
    kicker: "ENDORSED BRAND · BEAUTY",
    tagline: "Beauty and elegance, curated.",
    phone: "8111803387",
    intro:
      "Welcome to our exquisite emporium of beauty and elegance, where dreams and desires come alive. Emilia is your destination for cosmetic and ornamental needs, with every product curated to enhance your natural radiance and adorn your life with charm.",
    accent: "#CEA768",
    bg: "linear-gradient(150deg,#0e0e0e,#2b2620)",
    photos: false,
    products: ["Skincare", "Makeup", "Fragrances", "Ornaments", "Beauty Tools", "Gifting"],
    features: ["Expert beauty advisors", "Curated cosmetic ranges", "Ornaments and accessories", "by Konattu Group"],
  },
];

export const getDivision = (slug) => DIVISIONS.find((d) => d.slug === slug);
